<template>
  <div class="phone-appointment-thank-you-view row">

    <div class="col-12 bg-primary py-4 my-5 text-center">

      <h1 class="h2 text-white text-uppercase">
        {{ $t('phone_appointment.thank_you') }}
      </h1>

      <div class="text-white">
        {{ $t('phone_appointment.thank_you_info') }}
      </div>

    </div>

    <div class="col-12">

      <button type="button"
              class="btn btn-primary btn-block"
              @click="restart"
      >
        {{ $t('phone_appointment.restart_button') }}
      </button>

    </div>

  </div>
</template>

<script>

import {mapMutations} from 'vuex';

export default {
  name: 'PhoneAppointmentThankYouView',
  methods: {
    ...mapMutations({
      setQuestionPath: 'setQuestionPath',
    }),
    restart() {
      this.setQuestionPath([]);
      this.$router.push('/')
          .catch(alert);
    },
  },
};
</script>
